<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "noNavLayout",

  mounted(){

    this.getlogs()

    if (this.it_exists('getCanSendMessage')) {
      console.log("Can Send Message? :" + this.getAyoba()?.getCanSendMessage())
    }

    if (this.it_exists('sendMessage')) {
      this.getAyoba()?.sendMessage('Check out this short tutorial on how to start your radio. https://youtu.be/x-vflOldNrk ');

    }

  }

};
</script>


